import { listTree } from '../../extensions/bundled/documents/documentsStore';
import { updateDocumentTabScope, useTabsStore } from '../../store/tabsStore';

const isPersonal = (scope) => !scope?.type || scope.type === 'personal';
const scopeIdOf = (scope) => scope?.scopeId ?? null;

/**
 * The scope an open personal tab should carry for `node` (a bucket-level
 * `listTree` node, tagged with its root's workspace) — or null when it already
 * does. A tab that never named a workspace and still is in none is left as it
 * is, so a legacy `{ type: 'personal' }` tab keeps its exact shape.
 */
export function relocatedScope(scope, node) {
  if (!node || !isPersonal(scope)) return null;
  const next = node.scopeId || null;
  if (scopeIdOf(scope) === next) return null;
  return { ...(scope || { type: 'personal' }), scopeId: next };
}

/**
 * After a move between workspaces (Move to…, a drop on the switcher, a deleted
 * workspace — card 5.3): every open personal document tab is re-pointed at the
 * workspace its document now lives in, so breadcrumbs and reveals follow
 * without a reload. One bucket-level tree read covers every tab; sub-pages of
 * a moved tree follow their root.
 */
export async function relocateDocumentTabs() {
  const tabs = (useTabsStore.getState().documentTabs || []).filter((tab) => isPersonal(tab.scope));
  if (!tabs.length) return;
  let nodes;
  try {
    nodes = await listTree({ type: 'personal' });
  } catch {
    return; // a tab keeps its old workspace name until the next open
  }
  const byId = new Map(nodes.map((n) => [String(n.id), n]));
  for (const tab of tabs) {
    const next = relocatedScope(tab.scope, byId.get(String(tab.documentId)));
    if (next) updateDocumentTabScope(tab.documentId, next);
  }
}
